/**
 * @desc 采购退货单创建出库计划单
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(body: defs.fulfilment.PurchaseReturnCreateRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/rpc/outPlan/purchaseReturn`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
